module.exports = __webpack_public_path__ + "static/media/pays.eda381ec.png";